import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../request";
import { URL } from "../api";

const BreRulesList = () => {
  const navigate = useNavigate();
  const [breRules, setBreRules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingRuleId, setEditingRuleId] = useState(null);
  const [editedCriteria, setEditedCriteria] = useState("");

  useEffect(() => {
    fetchRules();
  }, []);

  const fetchRules = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(URL.BRE_RULES);
      setBreRules(response.data || []);
    } catch (err) {
      console.error("Error fetching BRE rules:", err);
    } finally {
      setLoading(false);
    }
  };

  const toggleActive = async (rule) => {
    const updatedActive = rule.isActive === 1 ? 0 : 1;
    try {
      await axiosInstance.post(`${URL.UPDATE_POLICY}?id=${rule.id}`, {
        isActive: updatedActive,
      });

      // Optimistic UI update
      setBreRules((prevRules) =>
        prevRules.map((r) =>
          r.id === rule.id ? { ...r, isActive: updatedActive } : r
        )
      );
    } catch (err) {
      console.error("Error updating active status:", err);
    }
  };

  const handleCriteriaClick = (rule) => {
    if (!rule.criteria) return;
    setEditingRuleId(rule.id);
    setEditedCriteria(rule.criteria || "");
  };

  const saveCriteria = async (rule) => {
    try {
      await axiosInstance.post(`${URL.UPDATE_POLICY}?id=${rule.id}`, {
        criteria: editedCriteria,
      });

      // Optimistic UI update
      setBreRules((prevRules) =>
        prevRules.map((r) =>
          r.id === rule.id ? { ...r, criteria: editedCriteria } : r
        )
      );

      setEditingRuleId(null);
      setEditedCriteria("");
    } catch (err) {
      console.error("Error updating criteria:", err);
    }
  };

  return (
    <div className="container mt-4">
      {/* ✅ Top-left back button */}
      <button
        className="btn btn-secondary mb-3"
        onClick={() => navigate(-1)}
      >
        ← Back
      </button>

      <h4 className="mb-3">Peday BRE Rules</h4>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="thead-light">
              <tr>
                <th>Sequence</th>
                <th>Policy Name</th>
                <th>Rule Name</th>
                <th>Criteria</th>
                <th>Active</th>
              </tr>
            </thead>
            <tbody>
              {breRules.map((rule) => (
                <tr key={rule.id}>
                  <td>{rule.sequence}</td>
                  <td>{rule.policyName}</td>
                  <td>{rule.ruleName}</td>
                  <td
                    style={{
                      cursor: rule.criteria ? "pointer" : "not-allowed",
                      color: !rule.criteria ? "#888" : "inherit",
                    }}
                    onClick={() =>
                      editingRuleId !== rule.id && handleCriteriaClick(rule)
                    }
                  >
                    {editingRuleId === rule.id ? (
                      <div className="d-flex">
                        <input
                          type="text"
                          className="form-control form-control-sm me-2"
                          value={editedCriteria}
                          onChange={(e) => setEditedCriteria(e.target.value)}
                        />
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => saveCriteria(rule)}
                        >
                          Save
                        </button>
                      </div>
                    ) : (
                      rule.criteria || <span className="text-muted">N/A</span>
                    )}
                  </td>
                  <td
                    className="text-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleActive(rule)}
                  >
                    {rule.isActive === 1 ? "✔️" : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default BreRulesList;
